import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { Logger } from '../utils/logger';
import { Content } from './Content';
import { Item } from './Item';

export interface Transcript extends Item {
  contentId: number;
  content?: Content;

  transcript: string;
  summary: string[];
}

export const translateTranscriptFromTransport = (attributes: any): any => {
  Logger.log(`attributes.summary: ${attributes?.summary}`);

  if (!attributes) {
    return attributes;
  }

  const { transcript, summary } = attributes;
  if (!transcript) {
    return attributes;
  }

  const newTranscript = isBase64(transcript) ? base64Decode(transcript) : transcript;

  let newSummary = [];

  try {
    if (attributes.summary && isBase64(attributes.summary)) {
      const decoded = base64Decode(attributes.summary);
      newSummary = JSON.parse(decoded);
      Logger.log(`Decoded summary: ${JSON.stringify(newSummary)}`);
    } else {
      newSummary = JSON.parse(attributes.summary);
    }
  } catch (error: any) {
    Logger.log(`Error decoding summary: ${error.message}`);
  }

  return {
    ...attributes,
    transcript: newTranscript,
    summary: newSummary,
  };
};

export const translateTranscriptForTransport = (attributes: any): any => {
  if (!attributes) {
    return attributes;
  }

  const { transcript, summary } = attributes;
  if (!transcript) {
    return attributes;
  }

  return {
    ...attributes,
    transcript: !isBase64(transcript) ? base64Encode(transcript) : transcript,
    summary:
      summary && !isBase64(summary)
        ? base64Encode(JSON.stringify(summary))
        : JSON.stringify(summary),
  };
};
